import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { Bar, Doughnut, Pie } from "react-chartjs-2";

class DashboardDyanamicChartWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showChart: true,
      showTable: false
    };
  }

  toggleView(type) {
    if (type === "chart") {
      this.setState({ showChart: true, showTable: false });
    } else {
      this.setState({ showChart: false, showTable: true });
    }
  }

  buildTable(columns, rows) {
  let result =
    "<table class='table table-bordered table-striped'><thead><tr>";

  for (let i = 0; i < columns.length; i++) {
    result += "<th>" + columns[i].label + "</th>";
  }

  result += "</tr></thead><tbody>";

  for (let i = 0; i < rows.length; i++) {
    result += "<tr>";

    for (let j = 0; j < columns.length; j++) {
      let key = columns[j].value;

      result +=
        j === 0
          ? "<td>"
          : "<td style='text-align:right'>";

      if (rows[i] && rows[i].hasOwnProperty(key)) {
        result += rows[i][key];
      } else {
        result += 0;
      }

      result += "</td>";
    }

    result += "</tr>";
  }

  result += "</tbody></table>";

  return result;
}

  renderChart() {
    const { chartType, chartData } = this.props;

    if (chartType === "bar") {
      return (
        <Bar
          data={chartData}
          options={{
            maintainAspectRatio: false,
            scales: {
              xAxes: [{ gridLines: { display: false } }],
              yAxes: [
                {
                  gridLines: { display: false },
                  ticks: { beginAtZero: true }
                }
              ]
            }
          }}
        />
      );
    }

    if (chartType === "pie") {
      return (
        <Pie
          data={chartData}
          options={{ maintainAspectRatio: false }}
        />
      );
    }

    if (chartType === "doughnut") {
      return (
        <Doughnut
          data={chartData}
          options={{ maintainAspectRatio: false }}
        />
      );
    }

    return null;
  }

  renderShimmer() {
  return (
    <div>
      <div style={{
        height: "20px",
        width: "40%",
        background: "#eee",
        marginBottom: "10px",
        borderRadius: "4px",
        animation: "pulse 1.5s infinite"
      }} />

      <div style={{
        height: "180px",
        width: "100%",
        background: "#f3f3f3",
        borderRadius: "6px",
        animation: "pulse 1.5s infinite"
      }} />

      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.4; }
            100% { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
}

  render() {
    const { title, columns, rows,loading  } = this.props;

    let tableHtml = "";
    if (columns && rows) {
      tableHtml = this.buildTable(columns, rows);
    }

    return (
      <div className="dashboard-box">
        <div className="dashboard-box-header">
          <div className="dashboard-box-title left">{title}</div>

          <div className="right">
            <button
              type="button"
              className="btn btn-default fa fa-list"
              style={{
                padding: "6px",
                color: this.state.showTable ? "#6e2d90" : "gray"
              }}
              onClick={() => this.toggleView("table")}
            />

            <button
              type="button"
              className="btn btn-default fa fa-bar-chart"
              style={{
                padding: "6px",
                color: this.state.showChart ? "#6e2d90" : "gray"
              }}
              onClick={() => this.toggleView("chart")}
            />
          </div>
        </div>

       <div className="dashboard-box-body">
  {loading ? (
    this.renderShimmer()
  ) : (
    <>
      {this.state.showChart && (
        <div className="chart">
          {this.renderChart()}
        </div>
      )}

      {this.state.showTable && (
        <div
          className="table-responsive"
          style={{ maxHeight: "250px", overflowY: "auto" }}
        >
          {ReactHtmlParser(tableHtml)}
        </div>
      )}
    </>
  )}
</div>
      </div>
    );
  }
}

export default DashboardDyanamicChartWidget;